import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="What is inside the ebook" className="bg-transparent" data-id="element-211" data-mp="184f1q1waxg7h">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: '19px',
      paddingBottom: "21px"
    }} data-id="element-212" data-mp="1c5gr7r0f2dw9">
        <div className="text-center" data-id="element-213" data-mp="1zvb1q1x9jqdc">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-grape" data-id="element-214" data-mp="1zwcq183ai9d0">
            🏥 THE AGE-IN-PLACE BLUEPRINT™
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-215" data-mp="24rs2pwpk9z7u">
            What Will You Find Inside?
          </h2>
          <p className="mt-2 text-base text-plum/60" data-id="element-216" data-mp="1vsogijv3l3p4">
            6 complete volumes · 200+ pages — Everything you need in one place.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-217" data-mp="fhar9hefw9ob">
            {pillars.map(p => <span key={p} className="rounded-full border border-grape/25 bg-lilac-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-plum-soft" data-id="element-218" data-mp="kfm0pr0toi60">
                {p}
              </span>)}
          </div>
          <p className="mt-8 font-display text-lg font-black uppercase tracking-[0.18em] text-plum-soft" data-id="element-219" data-mp="3jb6jga2vh5lp">
            📚 The 6-Volume Method
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-220" data-mp="3t6gl2wpczayy">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="group rounded-2xl border border-grape/15 bg-white p-5 transition-colors duration-200 ease-out hover:border-grape/45" style={{
          paddingTop: "10px",
          paddingBottom: "8px"
        }} data-id="element-221" data-mp="b0bwqk88365q" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-222" data-mp="pruaebdm0olx">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-lilac-soft font-display text-lg font-black text-grape" data-id="element-223" data-mp="wtr0krklkqvk">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-plum" data-id="element-224" data-mp="16rnajg1stfs3">
                  <span aria-hidden="true" data-id="element-225" data-mp="1bidin11lzwqh">{t.emoji} </span>
                  {t.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-plum/65" data-id="element-226" data-mp="1fj75rs7897ib">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-grape/25 bg-white p-6" data-id="element-227" data-mp="1khqt9x1gyrcs">
          <p className="text-center font-display text-lg font-black text-grape" data-id="element-228" data-mp="1pjg3jagvb0zt">
            ✅ Every volume includes
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-229" data-mp="1uff0hmg9hrbu">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-plum/75" data-id="element-230" data-mp="3rbun0dz28dic">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-231" data-mp="3qj7dmk5coa" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}